import styled from 'styled-components';
import { space } from 'nicollet-tokens';
import { BaseCell } from '../BaseCell/index.js';

const StyledCell = styled(BaseCell)`
  align-items: center;
  height: 76px;
  padding: ${space.generic.x4};
  box-sizing: border-box;
`;

export { StyledCell };
